import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cloneDeep, isEmpty, isObject, find, isArray } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MultiOptionArgument",
  props: {
    items: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: [Array, Object],
      default: () => []
    },
    triggerArguments: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const localValue = isObject(this.value) ? [] : this.value;
    return {
      customOption: {
        name: this.$t("global.words.custom"),
        value: ""
      },
      localValue
    };
  },
  computed: {
    isCustomSelected() {
      var _localValue$name;
      const localValue = Array.isArray(this.localValue) ? this.localValue[0] : this.localValue;
      return localValue && ((_localValue$name = localValue.name) == null ? void 0 : _localValue$name.toLowerCase()) === this.customOption.name.toLowerCase();
    },
    currentText() {
      if (isEmpty(this.localValue)) {
        return this.placeholder || this.$t("automations.selectItems");
      } else if (this.localValue.length === 1) {
        return this.localValue[0].name || this.$tc("global.messages.qtyDays", this.localValue[0].value, {
          qty: this.localValue[0].value
        });
      } else {
        return `${this.$t("global.words.itemsSelected", {
          count: this.localValue.length
        })}`;
      }
    },
    boardId() {
      const [{
        boardId
      }] = this.items;
      return boardId;
    },
    options() {
      var _context;
      if (!this.boardId) return this.items;
      const boards = this.triggerArguments.board || [];
      const selectedBoards = _mapInstanceProperty(boards).call(boards, ({
        value
      }) => value);
      return _filterInstanceProperty(_context = this.items).call(_context, item => _includesInstanceProperty(selectedBoards).call(selectedBoards, item.boardId));
    }
  },
  watch: {
    value(newValue) {
      this.localValue = newValue;
      this.parseValue();
    },
    localValue() {
      this.$emit("input", this.localValue);
    },
    isCustomSelected(value) {
      if (value) this.handleCustomDaysPicker({
        target: {
          value: "0"
        }
      });
    }
  },
  mounted() {
    this.parseValue();
  },
  methods: {
    select(item) {
      const {
        name
      } = item;
      if (name.toLowerCase() === this.customOption.name.toLowerCase()) {
        this.unselectAllItems();
      } else if (this.isSelected(this.customOption)) {
        this.unselectItem(this.customOption);
      }
      if (this.isSelected(item)) {
        this.unselectItem(item);
      } else {
        this.localValue.push(cloneDeep(item));
      }
    },
    isSelected(item) {
      const found = find(this.localValue, curr => curr.value === item.value);
      return !!found;
    },
    unselectItem(item) {
      var _context2;
      this.localValue = _filterInstanceProperty(_context2 = this.localValue).call(_context2, curr => {
        var _curr$name, _item$name;
        return curr.value !== item.value && ((_curr$name = curr.name) == null ? void 0 : _curr$name.toLowerCase()) != ((_item$name = item.name) == null ? void 0 : _item$name.toLowerCase());
      });
    },
    unselectAllItems() {
      this.localValue = [];
    },
    handleCustomDaysPicker({
      target: {
        value
      }
    }) {
      this.localValue[0].value = value;
    },
    parseValue() {
      if (isObject(this.value) && !isArray(this.value)) this.localValue = [this.value];
    }
  }
});